import { t } from '@lingui/macro';
import LockIcon from '@material-ui/icons/Lock';

import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { dateTimeFormatter } from '../../../utilities';
import { DEFAULT_INVALID_VALUE } from '../../../utilities/FormattingUtilities';
import { getAgentTypeIcon, getAgentTypeTooltip } from '../agents/AgentListHelper';
import { renderStatus } from '../agents/AgentRenderHelper';
import { AdminPages, buildPageTarget, buildRootPageTarget } from '../AdminLinkUtils';
import { VOIP_ADAPTER_TYPE } from './VoipConstants';

const callManagerFormatter = (configuration) => {
    const primaryCallManagerName = configuration?.primaryCallManagerName;

    if (!primaryCallManagerName) {
        return DEFAULT_INVALID_VALUE;
    }

    if (configuration?.securityMode === 'Enabled') {
        return (
            <>
                <LockIcon fontSize="inherit" titleAccess={t`Call Manager secure mode enabled`} />
                {primaryCallManagerName}
            </>
        );
    }

    return primaryCallManagerName;
};

const csvCallManagerFormatter = (configuration) => configuration?.primaryCallManagerName || DEFAULT_INVALID_VALUE;

export const getAgentListColumns = (classes) => [
    {
        type: COLUMN_TYPES.ICON,
        title: t`Type`,
        width: 74,
        mapping: 'typeIcon',
        sortable: true,
        csvFormatter: (value, row) => row.translatedType,
        className: classes.root,
        icons: [
            {
                getIcon: getAgentTypeIcon,
                getTooltip: getAgentTypeTooltip,
            },
        ],
    },
    {
        type: COLUMN_TYPES.LINK,
        title: t`Name`,
        mapping: 'name',
        width: 240,
        sortable: true,
        link: {
            target: buildPageTarget(AdminPages.VoipConfig),
        },
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Model`,
        mapping: 'modelShortDisplay',
        width: 120,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Status`,
        sortable: true,
        mapping: 'status',
        width: 130,
        className: classes.root,
        renderer: renderStatus,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`VoIP Status`,
        mapping: 'registrationStatus',
        className: classes.root,
        width: 130,
        sortable: true,
        renderer: renderStatus,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Configuration`,
        mapping: 'voipMode',
        width: 130,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Interface`,
        mapping: 'voipConfiguration.adapterType',
        mapper: (row) => {
            if (row?.voipConfiguration?.adapterType === VOIP_ADAPTER_TYPE.wireless) {
                return 'Wireless';
            }
            if (row?.voipConfiguration?.adapterType === VOIP_ADAPTER_TYPE.default) {
                return 'Wired';
            }
        },
        width: 120,
        sortable: false,
    },
    {
        type: COLUMN_TYPES.LINK,
        title: t`Call Manager`,
        mapping: 'voipConfiguration',
        sortProperty: 'voipConfiguration.primaryCallManagerName',
        width: 130,
        sortable: true,
        formatter: callManagerFormatter,
        csvFormatter: csvCallManagerFormatter,
        getTooltip: (row) => row?.voipConfiguration?.primaryCallManagerName || DEFAULT_INVALID_VALUE,
        link: {
            target: `${buildRootPageTarget(AdminPages.VoipConfig)}/callManagers/:voipConfiguration.primaryCallManager`,
        },
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`User ID`,
        mapping: 'sipUserId',
        width: 130,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Phone Number`,
        mapping: 'phoneNumber',
        width: 130,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Extension`,
        mapping: 'voipConfiguration.extension',
        width: 80,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`IP Version`,
        mapping: 'voipConfiguration.ipVersion',
        width: 120,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Last Registered`,
        mapping: 'voipConfiguration.registration.updatedAt',
        width: 220,
        sortable: true,
        formatter: dateTimeFormatter,
    },
];
